import { render } from "./AnswerTips.vue?vue&type=template&id=5af4f49e"
import script from "./AnswerTips.vue?vue&type=script&lang=js"
export * from "./AnswerTips.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__